import React, { FunctionComponent } from 'react';

import { StaticRouter } from 'react-router';

import { InitNavigate } from '../../components/navigation';
import { User } from '../user';
import RootContainer from './root-container';

export interface Props {
    location: string;
    user: User | null;
}

const Root: FunctionComponent<Props> = ({ location }) => {
    if (NODE) {
        return (
            <StaticRouter location={location}>
                <RootContainer />
            </StaticRouter>
        );
    }
    const { BrowserRouter } = require('react-router');
    return (
        <BrowserRouter>
            <InitNavigate />
            <RootContainer />
        </BrowserRouter>
    );
};

export default Root;
